import React, { createContext, useCallback } from 'react';

const initialState = {
  modals: [],
  createId: () => '',
  openModal: () => {},
  closeModal: () => {},
};

const ModalContext = createContext(initialState);

export function ModalProvider({ children }) {
  const [modals, setModals] = React.useState([]);

  const createId = useCallback(() => Math.random().toString(36).substr(2, 9), []);

  const openModal = useCallback(({ id, body }) => {
    setModals((prevState) => [...prevState, { id, body }]);
  }, []);

  const closeModal = useCallback((id) => {
    setModals((prevState) => prevState.filter((modal) => modal.id !== id));
  }, []);

  return (
    <ModalContext.Provider value={{
      modals, createId, openModal, closeModal,
    }}
    >
      {children}
    </ModalContext.Provider>
  );
}

export const useModals = () => React.useContext(ModalContext);
